module.exports = __webpack_public_path__ + "img/sa.8f3e4e41.svg";